import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, IconButton, TextField, InputAdornment } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Color } from '../../../assets/color';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import * as AuthActions from '../../../redux/actions/authAction';

import "../partner";

const PartnerLogin = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [inputFieldDetail, setInputFieldDetail] = useState({ email: '', password: '' });
    const [inputFieldError, setInputFieldError] = useState({});
    const [showPassword, setShowPassword] = useState(false);

    const handleInputFieldDetailError = (input, value) => setInputFieldError((prev) => ({ ...prev, [input]: value }));  //* Handle Input Field : Error
    const handleInputFieldDetail = (event) => setInputFieldDetail({ ...inputFieldDetail, [event?.target?.name]: event?.target?.value });  //* Handle Input Field : Data

    //! Handle Validation
    const handleValidation = () => {
        let isValid = true
        const { email, password } = inputFieldDetail;

        if (!email) { handleInputFieldDetailError("email", "Please Enter email"); isValid = false }
        if (!password) { handleInputFieldDetailError("password", "Please Enter Password"); isValid = false }
        return isValid;
    }

    //! Handle Submit
    const handleSubmit = () => {
        const { email, password } = inputFieldDetail;

        if (handleValidation()) {
            console.log({ ...inputFieldDetail });

            const payload = {
                data: { email, password },
                onComplete: () => navigate('/')
            }
            //! Dispatching API For Login 
            dispatch(AuthActions.partnerLogin(payload));
        }
    };

    return (
        <div style={{ backgroundSize: 'cover', backgroundRepeat: 'no-repeat', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
            {/* "backgroundImage": `url(${login_background})`, */}

            <div className="loginWrapper slideInFromBottomAnimation" style={{ border: `1px solid ${Color.primary}` }}>
                <div style={{ padding: '2rem 0rem 0rem 2rem', maxWidth: '30rem', borderRadius: 20, backgroundColor: 'white', padding: "2rem" }}>
                    <Grid container spacing={2}>
                        <Grid item lg={12} sm={12} md={12} xs={12} >
                            <div style={{ display: 'flex', flexDirection: 'column', }}  >
                                <div style={{ fontSize: '2rem', }}>Welcome Partner</div>
                                <div style={{ fontSize: '1.2rem', marginTop: 10 }}>Enter Your Details Below</div>
                            </div>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField label={<>Email <span style={{ color: "red" }}>*</span></>} variant="outlined" fullWidth
                                name="email"
                                value={inputFieldDetail?.email}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.email ? true : false}
                                helperText={inputFieldError.email}
                                onFocus={() => handleInputFieldDetailError("email", null)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={12} style={{ position: "relative" }}>
                            <TextField
                                label={<>Password <span style={{ color: "red" }}>*</span></>} variant="outlined" fullWidth
                                type={showPassword ? 'text' : 'password'}
                                name='password'
                                value={inputFieldDetail?.password}
                                onChange={handleInputFieldDetail}
                                error={inputFieldError.password ? true : false}
                                helperText={inputFieldError.password}
                                onFocus={() => handleInputFieldDetailError("password", null)}
                                InputLabelProps={{ shrink: true }}
                            />
                            <InputAdornment position='end' style={{ position: "absolute", right: "20px", top: "65%" }}>
                                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        </Grid>

                        <Grid item lg={12} sm={12} md={12} xs={12} sx={{}}>
                            <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                <Link to={'/auth/partner-forget-password'} style={{ textDecoration: 'none' }}>Forget Password</Link>
                            </div>
                        </Grid>

                        <Grid item lg={12} sm={12} md={12} xs={12} >
                            <div onClick={handleSubmit} style={{ padding: '15px 20px', textAlign: 'center', border: `1px solid ${Color.primary}`, borderRadius: '5px', backgroundColor: Color.primary, color: Color.white, fontSize: '16px', cursor: 'pointer' }}>Login</div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    )

}
export default PartnerLogin;
